export default __webpack_public_path__ + "static/media/telemed.8821b04c.svg";